import { CloseIcon } from 'assets/icons';
import React from 'react';

import './page-card.scss';

interface IPageCard {
  title?: string;
  titleColor?: string;
  onClose?: () => void;
  main: React.ReactNode;
  footer?: React.ReactNode;
  minHeight?: string;
}

const PageCard = ({
  title,
  onClose,
  main,
  footer,
  minHeight,
  titleColor,
}: IPageCard) => {
  return (
    <section
      className="page-card"
      style={{
        minHeight: minHeight || 'calc(100vh - 48px)',
      }}
    >
      {title && (
        <header className="page-card__header">
          <h1
            className="page-card__title"
            style={{
              color: titleColor || '#181818',
            }}
          >
            {title}
          </h1>
          {onClose && (
            <div className="page-card__close-button-container">
              <CloseIcon
                className="page-card__close-button"
                role="button"
                color="#2555FE"
                onClick={onClose}
              />
            </div>
          )}
        </header>
      )}
      <main className="page-card__main">{main}</main>
      {footer && <footer>{footer}</footer>}
    </section>
  );
};

export default PageCard;
